import React from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Button, Dialog } from "@blueprintjs/core";
import { msg } from "constants/message";
import { ShowIf } from 'components/utils';
import { GiaiQuyetDonThu, LetterProcessingWorkFlow } from 'api';
import { DropDownChonCanBoGiaiQuyet, DropDownMulipleUse, DropDownChonPhongBanThuocCoQuan } from 'components/tt-forms';
import { validatable } from 'components/utils';
import { Toastr } from 'modules/toastr';

class TruongPhongThuHoiDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

      donId: this.props.id,
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      content: '',
      params: {},
      noticeMsg: 'Thu hồi đơn thành công',
      coQuanQuanLyNguoiDung: {},

      // Tai GUI
      alias: '',
      listNextStates: '',
      nextState: '',
      canBoGiaiQuyet: '',
      phongBanGiaiQuyet: '',

      isOpen: false,
      confirm: false,
      btnLoading: false,
      showData: false,
      dataPhongBan: []
    }
  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        coQuanQuanLyNguoiDung: {
          id: userInfo.coQuanQuanLyId,
          ten: userInfo.tenCoQuanQuanLy
        }
      });
    }
  }

  componentDidMount() {

  }

  getPhongBanThuocCoQuan() {
    GiaiQuyetDonThu.actions.getPhongBanThuocCoQuan.request().then(res => {
      if(res.data._embedded) {
        this.setState({
          dataPhongBan: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getState(listNextStates, type) {

    let stateId = null;

    listNextStates.map((item, i) => {

      if (item.type == type) {

        stateId = item.stateId;
        return stateId;
      }
    })
    return stateId;
  }

  getCurrentForm(donId) {
    LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(res => {
      if (res.data) {

        let info = res.data;
        let dataNextStateFilter = [];

        if(info.listNextStates) {
          let data = [...info.listNextStates];
          let dataFilter = data.filter(props => {
            return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO'
          })
          let dataNextState = [...dataFilter];
          dataNextState.map(item => {
            let newItem = item;
            if (
              item.type == 'KET_THUC' ||
              item.type == 'CAN_BO_TDTH_LUU_DON' ||
              item.type == 'CAN_BO_PHONG_TDTH_LUU_HO_SO' ||
              item.type == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' ||
              item.type == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' ||
              item.type == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET'
              ) {
              newItem.tenVietTat = 'Tự xử lý';
              newItem.ten = 'Trưởng phòng tự xử lý';
            }
            dataNextStateFilter[dataNextStateFilter.length] = newItem;
          })
        }
        let invalidTypes = ['KET_THUC', 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN', 'CAN_BO_CHUYEN_PHONG_BAN_KHAC_TDTH'];
        let getPhongBan = dataNextStateFilter.find(state => state.type === "NHANTTXM_GIAO_PHONG_CUNG_CAP");
        if (getPhongBan) {
          let phoPhong = {
            stateId: getPhongBan.stateId,
            ten: "Trưởng phòng giao việc phó phòng",
            tenVietTat: "Giao việc phó phòng",
            type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
          };
          dataNextStateFilter.push(phoPhong);
        }
        dataNextStateFilter = dataNextStateFilter.filter(item => item && !invalidTypes.includes(item.type));
        this.setState({
          alias: info.currentForm.alias,
          listNextStates: dataNextStateFilter,
          showData: true
        })
      }
    }).catch(error => {

      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    })
  }

  postGiaiQuyetDon() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });

      let selectedState = this.state.listNextStates.filter(state => {
        return state.type == this.state.nextState
      });

      let params = {
        don: {
          id: Number(this.state.donId)
        },
        thongTinGiaiQuyetDon: {
          id: Number(this.state.thongTinGiaiQuyetDonId)
        }
      };

      if (this.state.phongBanGiaiQuyet) {
        params.phongBanGiaiQuyet = {
          id: Number(this.state.phongBanGiaiQuyet)
        }
      }

      if (this.state.canBoGiaiQuyet) {
        params.canBoXuLyChiDinh = {
          id: Number(this.state.canBoGiaiQuyet)
        }
      }

      if (this.state.listNextStates && this.state.listNextStates.length == 1) {
        params.nextState = {
          id: this.state.listNextStates[0].stateId
        }
      } else if (selectedState.length > 0) {
        params.nextState = {
          id: selectedState[0].stateId
        }
      }

      GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
        Toastr(msg.gqdGiaoViec, 'success');
        this.closeDialog();
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          btnLoading: false
        });
      });
    }
  }

  validateSubmitForm() {
    let pass = true;
    if (typeof this.props.validators['formTaoDon'] != 'undefined') {
      this.props.validators['formTaoDon'].map(validator => {
        if (pass) {
          pass = validator.validate();
        }
        else
          validator.validate();
      });
    }
    return pass;
  }

  toggleDialog() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  openDialog() {
    this.setState({
      isOpen: true,
      confirm: false,
      btnLoading: false
    });
    this.getCurrentForm(this.state.donId);
    this.getPhongBanThuocCoQuan();
  }

  closeDialog() {
    this.setState({
      isOpen: false
    });
    if (this.state.confirm) {
      this.props.getListData();
    }

  }

  confirm() {
    this.setState({
      btnLoading: true
    })
    let params = {
      don: {
        id: Number(this.state.donId)
      },
      nextState : {
        id: this.getState(this.state.listNextStates, (this.state.listNextStates.length > 0 ? this.state.listNextStates[0].type : 'TRUONG_PHONG_THU_HOI'))
      },
      thongTinGiaiQuyetDon: {
        id: Number(this.state.thongTinGiaiQuyetDonId)
      }
    };

    GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
      Toastr(this.state.noticeMsg, 'success');
      this.setState({
        confirm: true,
        btnLoading: false,
        showData: false
      })
      this.getCurrentForm(this.state.donId);
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      this.setState({
        btnLoading: false
      })
    });
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
    if (name == 'nextState') {
      this.setState({
        phongBanGiaiQuyet: '',
        canBoGiaiQuyet: ''
      });
    }
  }

  goToGiaiQuyetDon() {
    browserHistory.push('/tpth-giai-quyet-don/giai-quyet/' + this.state.donId);
  }

  render() {
    return (
      <div className="wrap-link-todo">
        <Link className="itt-thu-hoi" onClick={this.openDialog.bind(this)}>
          Thu hồi
        </Link>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.closeDialog.bind(this)}
          title='Thu hồi'
          className="reception-dialog delete-dialog">

            <div className="items-form">
              <div className="row pr15 pl15">
                <ShowIf condition={!this.state.confirm}>
                  <span className='col-100 text-13 txt-center pt25 pb25' >Sau khi xác nhận thu hồi, đơn sẽ được chuyển đến trang "Công việc đang giải quyết"</span>
                </ShowIf>
                <ShowIf condition={this.state.confirm}>
                  <ShowIf condition={this.state.listNextStates.length == 1}>
                    <span className='col-100 text-13 pt25 pl25 pb10'>Đơn đã thu hồi sẽ được giao cho:</span>
                  </ShowIf>
                  <ShowIf condition={this.state.listNextStates.length > 1}>
                    <div className='pt20'></div>
                  </ShowIf>
                  <div className='col-100 pl15 pb20 pr15'>
                    <ShowIf condition={this.state.listNextStates.length > 1}>
                      <DropDownMulipleUse
                        className="col-50 mb-18"
                        donId={this.state.id}
                        require
                        isValid={this.state.validate}
                        data={this.state.listNextStates}
                        bindValidator={this}
                        selectedValue={this.state.nextState}
                        label="Hướng giải quyết"
                        keyName='type'
                        name="huongGiaiQuyet"
                        valueName='tenVietTat'
                        onChange={this.onChange.bind(this, 'nextState')}
                      />
                    </ShowIf>
                    <ShowIf condition={this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' || this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG'}>
                      <DropDownMulipleUse
                        selectedValue={this.state.phongBanGiaiQuyet}
                        require
                        bindValidator={this}
                        className="col-50 mb-18"
                        keyName='coQuanQuanLyId'
                        valueName='ten'
                        label="Phòng ban giải quyết"
                        data={this.state.dataPhongBan}
                        onChange={this.onChange.bind(this, 'phongBanGiaiQuyet')}
                      />
                    </ShowIf>
                    <ShowIf condition={this.state.nextState === 'GQDTTTXM_GIAO_PHONG_CUNG_CAP' || this.state.nextState === "NHANTTXM_GIAO_PHONG_CUNG_CAP"}>
                      <DropDownChonPhongBanThuocCoQuan
                        className="col-50 mb0-18"
                        require
                        bindValidator={this}
                        selectedValue={this.state.phongBanGiaiQuyet}
                        isValid={this.props.validate}
                        onChange={this.onChange.bind(this, 'phongBanGiaiQuyet')}
                        name="dropdownChonPhongBanThuocCoQuan" />
                    </ShowIf>
                    <ShowIf condition={
                      (this.state.nextState == 'LANH_DAO_GIAO_VIEC_CAN_BO' ||
                      this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' ||
                      this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' ||
                      this.state.nextState == 'TRUONG_PHONG_TDTH_GIAO_VIEC_CAN_BO' ||
                      this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' ||
                      this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_LAP_DU_THAO' ||
                      this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO' ||
                      this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG')
                    }>
                      <DropDownChonCanBoGiaiQuyet
                        selectedValue={this.state.canBoGiaiQuyet}
                        require
                        coQuanQuanLyId={this.state.phongBanGiaiQuyet ? this.state.phongBanGiaiQuyet : this.state.coQuanQuanLyNguoiDung.id}
                        vaiTro={this.state.nextState == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' ? 'TRUONG_PHONG' :  (this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' ? 'PHO_PHONG' : 'CHUYEN_VIEN')}
                        bindValidator={this}
                        className="col-50 mb0-18"
                        label={this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' ? "Chọn phó phòng" :"Công chức giải quyết"}
                        onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                        name="dropdownChonCanBoGiaiQuyet"
                      />
                    </ShowIf>
                  </div>
                </ShowIf>
              </div>
              <span className='line-border mb20'></span>
            </div>

          <div className="pt-dialog-footer">
            <div className="pt-dialog-footer-actions reception-delete-confirm">
              <Button
                onClick={this.closeDialog.bind(this)}
                text="Không"
                className="btn-default"
              />
              <ShowIf condition={!this.state.confirm}>
                <Button
                  onClick={this.confirm.bind(this)}
                  text="Đồng ý"
                  className={this.state.btnLoading ? 'btn-green btn-loading-inline' : 'btn-green'}
                />
              </ShowIf>
              <ShowIf condition={this.state.confirm && this.state.nextState != ''}>
                <span>
                  <ShowIf condition={
                    this.state.nextState == 'KET_THUC' ||
                    this.state.nextState == 'CAN_BO_TDTH_LUU_DON' ||
                    this.state.nextState == 'CAN_BO_PHONG_TDTH_LUU_HO_SO' ||
                    this.state.nextState == 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' ||
                    this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' ||
                    this.state.nextState == 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET'
                  }>
                    <Button
                      onClick={this.goToGiaiQuyetDon.bind(this)}
                      text="Xác nhận"
                      className={this.state.btnLoading ? 'btn-green btn-loading-inline' : 'btn-green'}
                    />
                  </ShowIf>
                  <ShowIf condition={
                    this.state.nextState != 'KET_THUC' &&
                    this.state.nextState != 'CAN_BO_TDTH_LUU_DON' &&
                    this.state.nextState != 'CAN_BO_PHONG_TDTH_LUU_HO_SO' &&
                    this.state.nextState != 'CAN_BO_CHUYEN_VE_DON_VI_GIAI_QUYET' &&
                    this.state.nextState != 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' &&
                    this.state.nextState != 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET'
                  }>
                    <Button
                      onClick={this.postGiaiQuyetDon.bind(this)}
                      text="Giao Việc"
                      className={this.state.btnLoading ? 'btn-green btn-loading-inline' : 'btn-green'}
                    />
                  </ShowIf>
                </span>
              </ShowIf>
            </div>
          </div>
        </Dialog>
      </div>

    );
  }
}

TruongPhongThuHoiDialog.defaultProps = {
  validators: []
}

export default connect()(validatable(TruongPhongThuHoiDialog));



// WEBPACK FOOTER //
// ./src/components/modules/dialog/TruongPhongThuHoiDialog.jsx